import { useEffect } from 'react';
import { useUserContext } from 'App/contexts/UserContext';
import { configureDynatraceUser } from 'App/services/TrackingService';

const DynatraceDefineUser = () => {
    const user = useUserContext();

    useEffect(() => {
        if (!user?.id) {
            return undefined;
        }

        const companyId = user?.active_company?.ID;
        const stableUserId = companyId ? `${companyId}-${user.id}` : `${user.id}`;

        return configureDynatraceUser(stableUserId);
    }, [user?.active_company?.ID, user?.id]);

    return null;
};

export { DynatraceDefineUser };
